import pick from 'lodash/pick';
import { typhonAjaxFetch } from '~/helpers/api';
import { typhonRoutes } from '~/helpers/routes';
import log from '~/helpers/logging';

// Get matrix model by id
async function getMatrixModel(typhonDomain, matrixToken, matrixVersion = '') {
  const url = `${typhonDomain}${typhonRoutes.matrixModels.get(matrixToken, matrixVersion)}`;
  try {
    return await typhonAjaxFetch(url, { silent: true });
  } catch (exception) {
    log('error', `GET ${url} exception`, {}, exception);
    return exception;
  }
}
const handleMatrixErrors = async resp => {
  const response = await resp.json();
  if (response.error) {
    window.addSnackBar({
      title: response.error.message,
      type: 'danger',
    });
  }
  return response;
};

// Creates a matrix model with the passed payload.
// If no payload is passed - we'll use these hard-coded
// values for now, just for testing.
// Needs the typhon domain to be specified.
function createMatrixModel(typhonDomain, payload = {}) {
  if (payload.actionId) {
    delete payload.actionId;
  }

  const url = `${typhonDomain}${typhonRoutes.matrixModels.create}`;
  return typhonAjaxFetch(
    url,
    { method: 'POST', body: JSON.stringify(payload) },
    handleMatrixErrors,
  );
}

// Updates the specified matrix model with the passed payload
function updateMatrixModel(typhonDomain, matrixToken, updatePayload) {
  const url = `${typhonDomain}${typhonRoutes.matrixModels.update(matrixToken)}`;
  return typhonAjaxFetch(url, { method: 'PATCH', body: JSON.stringify(updatePayload) });
}

/**
 * Side effect: Shows snackbar to alert if a matrix is misconfigured.
 * @returns boolean
 */
function areMatrixModelDataRoutesValid(
  matrixModels, dataRouteMatrixModelAxis, actions, alertFn,
) {
  let valid = true;
  matrixModels.forEach(matrixModel => {
    ['x', 'y'].forEach(axis => {
      if (dataRouteMatrixModelAxis[matrixModel.actionId]
            && dataRouteMatrixModelAxis[matrixModel.actionId][axis]) {
        // get action to check if it is a service
        // if it is a service, ensure the attribute is set
        const matrixAxisDataRoute = dataRouteMatrixModelAxis[matrixModel.actionId][axis];
        const sourceAction = actions.find(
          action => action.id === matrixAxisDataRoute.sourceId,
        );

        if ((!sourceAction) || (sourceAction.type === 'run' && !matrixAxisDataRoute.attribute.id)) {
          valid = false;
          alertFn({
            title: `${axis}-axis misconfigured for matrix ${matrixModel.name}, please reset your axis`,
            type: 'danger',
          });
        }
      }
    });
  });
  return valid;
}

const getAttributeDataForDataRoute = attributesByAttributedId => {
  const attribute = Object
    .values(attributesByAttributedId || {})
    .find(({ archivedAt, dataType }) => (
      !archivedAt
      && (dataType === 'decimal' || dataType === 'integer')
    ));
  if (!attribute) throw new Error('no attribute found');
  return {
    ...pick(attribute, [
      'attribute_name',
      'description',
      'display_name',
      'id',
      'is_multilevel',
      'name',
    ]),
    multi_level_attribute_filter: {
      filter_components: attribute.components,
    },
  };
};

export {
  getMatrixModel,
  createMatrixModel,
  updateMatrixModel,
  areMatrixModelDataRoutesValid,
  getAttributeDataForDataRoute,
};
